import React from 'react';
import {
  Box,
  Card,
  CardBody,
  Text,
  VStack,
  SimpleGrid,
  useColorModeValue,
} from '@chakra-ui/react';

const VendorProfile: React.FC = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <Box maxW="1400px" mx="auto" p={6}>
      <Card bg={bgColor} borderColor={borderColor}>
        <CardBody>
          <VStack spacing={4}>
            <Text fontSize="2xl" fontWeight="bold">
              Vendor Profile Management
            </Text>
            <Text color="gray.600" textAlign="center">
              Manage your company information, capabilities, certifications, and contact details.
            </Text>
            <Text fontSize="sm" color="blue.600">
              Coming soon: Complete profile management interface
            </Text>
          </VStack>
        </CardBody>
      </Card>
    </Box>
  );
};

export default VendorProfile; 